import { render, staticRenderFns } from "./MzKaraoke.vue?vue&type=template&id=040127ea&scoped=true&"
import script from "./MzKaraoke.vue?vue&type=script&lang=js&"
export * from "./MzKaraoke.vue?vue&type=script&lang=js&"
import style0 from "./MzKaraoke.vue?vue&type=style&index=0&id=040127ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040127ea",
  null
  
)

export default component.exports